import React from 'react';
import IndustryDetailPage from './IndustryDetailPage.jsx';

function TestimonialPharma() {
  return <IndustryDetailPage industry="pharma" />;
}

export default TestimonialPharma;
